import * as S from './RightRailNavigationStyles';

export interface MenuItemContent {
  title: string;
  url: string;
}
interface MenuItemProps {
  menuTitle: string;
  content: MenuItemContent[];
  isMenuOpen: boolean;
  onClick: () => void;
  index: number;
}
const MenuItem = ({ menuTitle, content, isMenuOpen, onClick, index }: MenuItemProps) => (
  <S.MenuWrapper className='menu-wrapper'>
    {/** biome-ignore lint/a11y/useSemanticElements: is needed */}
    <S.MenuHeader
      id={`menuHeader-${index}`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick();
      }}
      tabIndex={0}
      role='button'
      className={isMenuOpen ? 'up' : undefined}
      aria-expanded={isMenuOpen}
      aria-controls={`menuContent-${index}`}
    >
      <S.MenuTitle
        className='menu-title'
        as='h3'
        $fontFamily='graphikCond'
        $size={{ default: 'level3' }}
      >
        {menuTitle}
      </S.MenuTitle>
      <S.Arrow
        className='arrow'
        aria-hidden='true'
      />
    </S.MenuHeader>
    <S.MenuContent
      id={`menuContent-${index}`}
      $open={isMenuOpen}
      aria-labelledby={`menuHeader-${index}`}
    >
      {content.map((submenu) => (
        <S.Submenu key={submenu.title}>
          <S.SubmenuTitle
            href={submenu.url}
            ariaLabel={`Go to ${submenu.title} ranking`}
          >
            {submenu.title}
          </S.SubmenuTitle>
        </S.Submenu>
      ))}
    </S.MenuContent>
  </S.MenuWrapper>
);

export default MenuItem;
